import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { Link, NavLink } from 'react-router-dom';
import { cartItemModel, userModel } from '../../Interfaces';
import { RootState } from '../../Storage/Redux/store';
import { emptyUserState, setLoggedInUser } from '../../Storage/Redux/userAuthSlice';
import { SD_Roles } from '../../Utility/SD';
let logo = require("../../Assests/Images/mango.png");
function Header() {
  const shoppingCartFromStore: cartItemModel[] = useSelector(
    (state: RootState) => state.shoppingCartStore.cartItems ?? []
  );
   
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const userData: userModel = useSelector(
    (state: RootState) => state.userAuthStore
  );

  function handleLogout(){
    sessionStorage.clear();
    dispatch(setLoggedInUser({ ...emptyUserState }));
    navigate("/")
  }
  const nav = useNavigate()
  return (
    <>
    <div>
      <nav className="navbar navbar-expand-lg bg-dark navbar-dark">
        <div className="container-fluid">
          <NavLink className="nav-link" aria-current="page" to="/">
             <i className="fas fa-utensils my-auto"
                 style={{
                  fontSize: "30px", color: "green"}}> PASIGO</i>
          </NavLink>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0 w-100">
              {userData.role == SD_Roles.ADMIN ? (
                <li className="nav-item dropdown">
                  <a
                    className="nav-link dropdown-toggle"
                    href="#"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Admin Panel
                  </a>
                  <ul className="dropdown-menu">
                    <li
                      style={{ cursor: "pointer" }}
                      className="dropdown-item"
                      onClick={() => navigate("menuItem/menuitemlist")}
                    >
                      Menu Item
                    </li>
                    <li
                      style={{ cursor: "pointer" }}
                      className="dropdown-item"
                      onClick={() => navigate("order/myorders")}
                    >
                      My Orders
                    </li>
                    <li
                      style={{ cursor: "pointer" }}
                      className="dropdown-item"
                      onClick={() => navigate("order/allOrders")}
                    >
                      All Orders
                    </li>
                  </ul>
                </li>
              ) : sessionStorage.getItem("token")?
                <>
                <li className="nav-item">
                  <NavLink
                    className="nav-link"
                    aria-current="page"
                    to="/order/myorders"
                  >
                    Orders
                  </NavLink>
                </li>
                <li className="nav-item">
                <NavLink
                  className="nav-link"
                  aria-current="page"
                  to="/shoppingCart"
                >
                  <i className="bi bi-cart"></i>{" "}
                  {userData.id && `(${shoppingCartFromStore.length})`}
                </NavLink>
                </li>
              <li className="nav-item d-block d-lg-none d-md-none d-xl-none" >
              <NavLink
                  className="nav-link"
                  aria-current="page"
                  to="/"
                  onClick={handleLogout}
                >Logout
                </NavLink>
              </li>
                </>
                :
                <></>
              }
              <div className="d-xl-flex d-md-flex d-lg-flex d-none d-lg-block d-xl-block" style={{ marginLeft: "auto" }}>
                {userData.id && (
                  <>
                    <li className="nav-item">
                      <button
                        className="nav-link active"
                        style={{
                          cursor: "pointer",
                          background: "transparent",
                          border: 0,
                        }}
                      >
                        Welcome, {userData.fullName}
                      </button>
                    </li>
                    <li className="nav-item d-none d-lg-block d-xl-block">
                      <button
                        className="btn btn-success btn-outlined rounded-pill text-white mx-2"
                        style={{
                          border: "none",
                          height: "40px",
                          width: "100px",
                        }}
                        onClick={handleLogout}
                      >
                        Logout
                      </button>
                    </li>
                  </>
                )}

                {!userData.id && (
                  <>
                    <li className="nav-item text-white d-none d-lg-block d-xl-block">
                      <NavLink className="nav-link" to="/register">
                        Register
                      </NavLink>
                    </li>
                    <li className="nav-item text-white d-none d-lg-block d-xl-block">
                      <NavLink
                        className="btn btn-success btn-outlined rounded-pill text-white mx-2"
                        style={{
                          border: "none",
                          height: "40px",
                          width: "100px",
                        }}
                        to="/login"
                      >
                        Login
                      </NavLink>
                    </li>
                  </>
                )}
              </div>
              <div className="d-block d-md-none d-lg-none d-xl-none">
                {!userData.id && (
                  <>
                    <li className="nav-item d-block d-lg-none d-md-none d-xl-none" >
              <NavLink
                  className="nav-link"
                  aria-current="page"
                  to="/register"
                >Register
                </NavLink>
                    </li>
                    <li className="nav-item d-block d-lg-none d-md-none d-xl-none" >
              <NavLink
                  className="nav-link"
                  aria-current="page"
                  to="/login"
                >Login
                </NavLink>
                    </li>
                  </>
                )}
              </div>
            </ul>
          </div>
        </div>
      </nav>
    </div>
    </>
  )
}

export default Header